import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace("#", ""));
      const sessionId = params.get("session_id");

      if (!sessionId) {
        toast.error("Sessão inválida");
        navigate("/login", { replace: true });
        return;
      }

      try {
        const result = await exchangeSession(sessionId);
        toast.success(`Bem-vindo, ${result.user.name}!`);
        // Navigate to dashboard passing user data to skip auth check
        navigate("/dashboard", { replace: true, state: { user: result.user } });
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error("Erro ao autenticar com Google");
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-muted-foreground">A autenticar...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
